module.exports = __webpack_public_path__ + "static/fonts/342F4F_6_0.bf7b7ce.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_6_0.eot
// module id = 53
// module chunks = 4